import * as React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import PropTypes from 'prop-types';

export default function ProgressLoader({ time = 1500 }) {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    const startTime = Date.now();
    const duration = time; // 3 seconds

    const timer = setInterval(() => {
      const elapsedTime = Date.now() - startTime;
      const newProgress = Math.min((elapsedTime / duration) * 100, 100);

      setProgress(newProgress);

      // Stop the interval when progress reaches 100%
      if (newProgress >= 100) {
        clearInterval(timer);
      }
    }, 10); // Update frequently for smooth animation

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Box sx={{ width: '100%', position: 'absolute', top: 0 }}>
      <LinearProgress variant="determinate" value={progress} color="tertiary" />
    </Box>
  );
}

ProgressLoader.proptypes = {
  time: PropTypes.any
};
